import { Close as CloseIcon } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useSnackbar } from 'notistack'

interface SnackbarCloseButtonProps {
  snackbarKey?: number | string
}

const SnackbarCloseButton = ({ snackbarKey }: SnackbarCloseButtonProps) => {
  const { closeSnackbar } = useSnackbar()

  return (
    <IconButton
      sx={{ color: 'inherit' }}
      aria-label="close"
      size="small"
      onClick={() => closeSnackbar(snackbarKey)}
    >
      <CloseIcon sx={{ width: '0.75em' }} />
    </IconButton>
  )
}

export default SnackbarCloseButton
